import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  chargeCreation,
  getAllCharges,
  getJobInfo,
  getTemplateDetails,
  saveTemplate,
} from "../../api/finance/addChargesApi";
import {getBulkDropdownData, getDropdownData} from "../../api/keyvalue";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { chargeTemplateCreationValidation } from "../../components/validations/ChargeCreation";
import Button from "../../components/input/Button";
import Input from "../../components/input/Input";
import Dropdown from "../../components/input/Dropdown";
import Modal from "../../components/Modal";
import SelectRenderer from "../../components/renderer/SelectRenderer";
import Grid from "../../components/Grid";
import { DollarSign } from "react-feather";
import LoadingSpinner from "../../components/LoadingSpinner";
import InfoList from "../../components/InfoList";
import { ResizableScrollingTextRenderer } from "../../components/renderer/StyleRenderer";
import ButtonRenderer from "../../components/renderer/ButtonRenderer";
import SearchDropdown from "../../components/input/SearchDropdown";
import { currencyContains } from "../../api/currencyApi";

const mode = {
  CREATE: 1,
  EDIT: 2,
};

const AddMultipleCharges = ({
  jobIds,
  jobCodes,
  template,
  handleDrawerClose,
  setUpdateNeeded,
  setUpdateTemplates,
  updateTemplates,
  isAdditional,
}) => {
  const [isJobInfoLoading, setIsJobInfoLoading] = useState(false);
  const [jobSummerys, setJobSummerys] = useState({});
  const [jobData, setJobData] = useState([]);
  const user = useSelector((state) => state.user);
  const gridRef = useRef(null);

  const [chargeOpt, setChargeOpt] = useState([]);
  const [revCostOpt, setRevCostOpt] = useState([]);
  const [uomOpt, setUomOpt] = useState([]);
  const [statusOpt, setStatusOpt] = useState([]);
  const [activeOpt, setActiveOpt] = useState([]);
  const [customerSupplierOpt, setCustomerSupplierOpt] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [templateDetailsLoading, setTemplateDetailsLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [rowCount, setRowCount] = useState(2);
  const [selectedRows, setSelectedRows] = useState([]);

  const [templateName, setTemplateName] = useState("");
  const [category, setCategory] = useState("");
  const [templateDescription, setTemplateDescription] = useState("");
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [currentErrors, setCurrentErrors] = useState({});
  const [drawerTab, setDrawerTab] = useState(1);

  useEffect(() => {
    (async () => {
      setIsJobInfoLoading(true);
      let jobSummeryObject = {};
      let jobInfoArray = [];

      for (let jobId of jobIds) {
        const response = await getJobInfo(jobId);
        const jobInfoData = response ? response[0] : {};
        const jobInfoObject = [
          {
            title: "Job Code",
            value: jobInfoData.jobCode ? jobInfoData.jobCode : "N/A",
          },
          {
            title: "Request Code",
            value: jobInfoData.reqCode ? jobInfoData.reqCode : "N/A",
          },
          {
            title: "Customer",
            value: jobInfoData.customerName ? jobInfoData.customerName : "N/A",
          },

          {
            title: "Shipper",
            value: jobInfoData.shipperName ? jobInfoData.shipperName : "N/A",
          },
          {
            title: "Billing Customer",
            value: jobInfoData.billinCustomer
              ? jobInfoData.billinCustomer
              : "N/A",
          },
          {
            title: "Invoicing Customer",
            value: jobInfoData.invoicingCustomer
              ? jobInfoData.invoicingCustomer
              : "N/A",
          },
          {
            title: "Vehicle No",
            value: jobInfoData.vehVehicleno ? jobInfoData.vehVehicleno : "N/A",
          },
          {
            title: "Transporter",
            value: jobInfoData.transporterName
              ? jobInfoData.transporterName
              : "N/A",
          },
          {
            title: "Rate Type",
            value: jobInfoData.rateType ? jobInfoData.rateType : "N/A",
          },
          {
            title: "VHT Type",
            value: jobInfoData.vhtType ? jobInfoData.vhtType : "N/A",
          },
          {
            title: "Negotiation",
            value: jobInfoData.negotiation ? jobInfoData.negotiation : "N/A",
          },
        ];

        jobSummeryObject = {
          ...jobSummeryObject,
          [jobInfoData.jobCode]: jobInfoObject,
        };
        jobInfoArray.push(jobInfoData);
      }

      setJobSummerys(jobSummeryObject);
      setJobData(jobInfoArray);

      setIsJobInfoLoading(false);
    })();
  }, [jobIds]);

  console.log("jobData", jobData);
  console.log("jobSummerys", jobSummerys);

  useEffect(() => {
    (async () => {
      setTemplateDetailsLoading(true);
      const templateData = await getTemplateDetails(template);
      console.log("templateData", templateData);
      if (templateData?.length > 0) {
        const data = templateData.map((item, index) => {
          return {
            id: index,
            chdChacrges: item.chtId,
            chdDescription: item.incDescription,
            value: null,
            chdQty: 1,
            chdTotal: null,
            chdUom: item.chtUom,
            chdStatus: 2,
            chdActive: 1,
            chdChargeType: item.incChgType?.toString(),
            mode: mode.CREATE,
          };
        });
        setGridData(data);
        setRowCount(data.length);
      } else {
        setGridData([]);
        setRowCount(2);
      }
      setTemplateDetailsLoading(false);
    })();
  }, [template]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const charges = await getAllCharges();
      setChargeOpt(charges);

      const {
        status,
        active,
        revcost:revCost,
        uom:uom,
        rate_type_for: rateTypes
      } = await getBulkDropdownData([
        {key:"status"},
        {key:"active"},
        {key:"revcost"},
        {key:"uom"},
        {key:"rate_type_for"},
      ]);
      setRevCostOpt(revCost);
      setUomOpt(uom);
      setStatusOpt(status);
      setActiveOpt(active);
      setCustomerSupplierOpt(rateTypes);
    })();
  }, []);

  const handleSelectionChanged = useCallback(() => {
    const selectedData = gridRef.current.getSelectedData();
    setSelectedRows(selectedData);
  }, []);

  const handleAddRow = () => {
    let currentRowCount = rowCount + 1;
    const newRow = {
      id: currentRowCount,
      chdChacrges: "",
      chdDescription: "",
      chdValue: null,
      chdQty: 1,
      chdTotal: null,
      chdUom: "",
      chdStatus: 2,
      chdActive: 1,
      chdChargeType: "",
      mode: mode.CREATE,
    };

    setGridData([...gridData, newRow]);
    setRowCount(currentRowCount);
  };

  const cellEditorParams = (params) => {
    console.log("params", params);
    switch (params.colDef.field) {
      case "chdValue": {
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              return {
                ...row,
                chdValue: Math.abs(params.value),
                chdTotal: Math.abs(params.data.chdQty) * Math.abs(params.value),
              };
            }
            return row;
          }),
        );
        break;
      }
      case "chdQty": {
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              return {
                ...row,
                chdQty: Math.abs(params.value),
                chdTotal:
                  Math.abs(params.data.chdValue) * Math.abs(params.value),
              };
            }
            return row;
          }),
        );
        break;
      }
      case "chdDescription": {
        setGridData((prev) =>
          prev.map((row) => {
            if (row.id === params.data.id) {
              return {
                ...row,
                chdDescription: params.value,
              };
            }
            return row;
          }),
        );
        break;
      }

      default:
    }
  };

  const resetForm = () => {
    setGridData([]);
    setSelectedRows([]);
    setRowCount(2);
  };

  const chargeValidator = () => {
    let isValid = true;
    for (let row of selectedRows) {
      if (row.chdChacrges === "") {
        isValid = false;
        break;
      }
      if (row.chdChargeType === "") {
        isValid = false;
        break;
      }
      if (row.chdDescription === "") {
        isValid = false;
        break;
      }
      if (row.chdValue === null) {
        isValid = false;
        break;
      }
      if (row.chdQty === null) {
        isValid = false;
        break;
      }
      if (row.chdUom === "") {
        isValid = false;
        break;
      }
      if (row.chdStatus === "") {
        isValid = false;
        break;
      }
      if (row.chdActive === "") {
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  const qtyAndValueValidator = () => {
    let isValid = true;
    for (let row of selectedRows) {
      if (row.chdValue < 0) {
        isValid = false;
        break;
      }
      if (row.chdQty === 0) {
        isValid = false;
        break;
      }
    }
    return isValid;
  };

  const addCharge = async (e) => {
    e.preventDefault();

    setIsSubmitLoading(true);

    if (selectedRows.length === 0) {
      toast.error("Please add charges", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    }

    if (!chargeValidator()) {
      toast.error("Please fill all the fields in the grid", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    }

    if (!qtyAndValueValidator()) {
      toast.error("Qty should be greater than 0", {
        autoClose: 5000,
        containerId: "Main",
      });
      setIsSubmitLoading(false);
      return;
    }

    for (let item of jobData) {
      const response = await chargeCreation({
        jobChargeHeader: {
          chhRequest: item.jobRequest,
          chhJobId: item.jobId,
          chhCustomer: item.customerId,
          chhSupplier: item.transId,
          chhVehicle: item.jobVehicle,
          chhKm: item.chargeableValue,
          chhRevenue: selectedRows?.reduce((acc, item) => {
            if (item.chdStatus === 2) {
              if (parseInt(item.chdChargeType) === 1) {
                return acc + item.chdTotal;
              }
            }
            return acc;
          }, 0),
          chhCost: selectedRows?.reduce((acc, item) => {
            if (item.chdStatus === 2) {
              if (parseInt(item.chdChargeType) === 2) {
                return acc + item.chdTotal;
              }
            }
            return acc;
          }, 0),
          chhCurrency: currency,
          chhExchangeRate: null,
          chhDescription1: "",
          chhDescription2: "",
          chhFormDate: item.fromDate,
          chhToDate: item.toDate,
          chhEvStatus: 1,
          chhInvStatus: 1,
          chhStatus: 2,
          chhActive: 1,
          chhAdditional: isAdditional,
        },
        jobChargeDetails: selectedRows?.map((item) => ({
          chdChargeType: item.chdChargeType,
          chdChacrges: item.chdChacrges,
          chdValue: item.chdValue,
          chdCurrency: item.currency,
          chdQty: item.chdQty,
          chdDescription: item.chdDescription,
          chdUom: item.chdUom,
          chdTotal: item.chdTotal,
          chdStatus: item.chdStatus,
          chdActive: item.chdActive,
        })),
        author: user.username,
      });

      console.log("creation response", response);
      if (response.status === 201) {
        toast.success(response.data + " !", {
          autoClose: 5000,
          containerId: "Main",
        });
        resetForm();
        handleDrawerClose();
        setUpdateNeeded(true);
      } else {
        toast.error(response.data, { autoClose: 5000, containerId: "Main" });
      }
    }

    setIsSubmitLoading(false);
  };

  const modalRef = useRef();
  const openModal = () => {
    modalRef.current?.showModal();
  };

  const closeModal = () => {
    modalRef.current.close();
  };

  const saveAsTemplate = async (e) => {
    e.preventDefault();
    setSavingTemplate(true);

    const templateErrors = chargeTemplateCreationValidation({
      intTemplateName: templateName,
      intCategory: category,
    });

    if (Object.keys(templateErrors).length > 0) {
      setCurrentErrors(templateErrors);
      document.querySelector(".ui.form").classList.add("error");
      toast.error("please Fill the required fields", {
        autoClose: 5000,
        containerId: "Main",
      });
      setSavingTemplate(false);
      return;
    } else {
      setCurrentErrors({});
      document.querySelector(".ui.form").classList.remove("error");

      for (let row of selectedRows) {
        if (row.chdChacrges === "") {
          toast.error("Please select charges for all rows", {
            autoClose: 5000,
            containerId: "Main",
          });
          setSavingTemplate(false);
          return;
        }
      }

      const response = await saveTemplate({
        chargeTemplateRequest: {
          intTemplateName: templateName,
          intCategory: category,
          intDescription: templateDescription,
          intStatus: 2,
          intActive: 1,
          intStakeholder: null,
        },
        templateChargesRequests: selectedRows?.map((item, index) => ({
          incCharge: item.chdChacrges,
          incDescription: item.chdDescription,
          incStatus: 2,
          incActive: 1,
          incSeq: index + 1,
          incChgType: item.chdChargeType,
        })),
        author: user.username,
      });

      console.log("response", response);
      if (response.status === 201) {
        toast.success(response.data + " !", {
          autoClose: 5000,
          containerId: "Main",
        });
      } else {
        toast.error(response.data, { autoClose: 5000, containerId: "Main" });
      }
    }

    setUpdateTemplates(!updateTemplates);
    closeModal();
    setSavingTemplate(false);
  };

  const [currency, setCurrency] = useState(143);
  //   const [currencyName, setCurrencyName] = useState("");
  const [searchFieldReset, setSearchFieldReset] = useState(false);
  const [selectedJob, setSelectedJob] = useState(jobCodes[0].value);

  console.log("jobCodes", jobCodes);
  console.log("Currrency", currency);
  console.log("Selected Job", selectedJob);

  return (
    <>
      <div className="drawer-content">
        <div className="ui top attached tabular menu">
          <div
            className={`item ${drawerTab === 1 ? "active" : ""}`}
            onClick={() => {
              setDrawerTab(1);
            }}
          >
            <span>
              <DollarSign
                size={15}
                style={{
                  marginRight: "5px",
                }}
              />
            </span>
            <label>Pick Charges</label>
          </div>
        </div>
        <div
          className="ui bottom attached active tab segment"
          style={{ display: drawerTab === 1 ? "block" : "none" }}
        >
          {isLoading || templateDetailsLoading || isJobInfoLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <div className="ui form">
                <div className="two fields">
                  <SearchDropdown
                    key={1}
                    label="Currency"
                    defaultValue={"Sri Lanka Rupee"}
                    reset={searchFieldReset}
                    setReset={setSearchFieldReset}
                    onResultSelect={(data) => setCurrency(data)}
                    api={currencyContains}
                    fieldInfo={{
                      tableName: "masterdata.tms_vm_reg_currency",
                      primaryKey: "cur_id",
                      fieldName: "cur_currency",
                      id: currency,
                    }}
                  />
                  <Dropdown
                    clearable={false}
                    label="Jobs"
                    placeholder="Jobs"
                    options={jobCodes}
                    value={selectedJob}
                    onChange={(e, data) => {
                      setSelectedJob(data.value);
                    }}
                  />
                </div>
              </div>
              {
                <InfoList
                  content={jobSummerys[selectedJob]}
                  title={`Job Summary of ${selectedJob}`}
                />
              }

              <div className="ui segment">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <button className="ui primary button" onClick={handleAddRow}>
                    <i className="plus icon"></i>ADD
                  </button>
                  <button
                    className="ui primary button"
                    onClick={openModal}
                    disabled={
                      gridData.length === 0 || selectedRows.length === 0
                        ? true
                        : false
                    }
                  >
                    <i className="save icon"></i>SAVE AS TEMPLATE
                  </button>
                </div>

                <Grid
                  ref={gridRef}
                  searchable={false}
                  multiRowSelection={true}
                  showDownloadButton={true}
                  downloadOnlySelected={true}
                  heading="Add Charges"
                  stopEditingWhenCellsLoseFocus={true}
                  onSelectionChanged={handleSelectionChanged}
                  onCellEditingStopped={cellEditorParams}
                  content={gridData}
                  config={[
                    {
                      headerCheckboxSelection: true,
                      checkboxSelection: true,
                      field: "",
                      pinned: "left",
                      minWidth: 50,
                      width: 50,
                    },
                    {
                      headerName: "Charge",
                      field: "chdChacrges",
                      cellRenderer: SelectRenderer,
                      cellRendererParams: (params) => ({
                        onChangeHandler: (data) => {
                          setGridData((prev) =>
                            prev.map((item) => {
                              if (item.id === params.data.id) {
                                return {
                                  ...item,
                                  chdChacrges: data,
                                };
                              }
                              return item;
                            }),
                          );
                        },
                        options: chargeOpt,
                        placeholder: "Select Charge",
                        value: params.data.chdChacrges,
                      }),
                    },
                    {
                      headerName: "Charge Type",
                      field: "chdChargeType",
                      cellRenderer: SelectRenderer,
                      cellRendererParams: (params) => ({
                        onChangeHandler: (data) => {
                          setGridData((prev) =>
                            prev.map((item) => {
                              if (item.id === params.data.id) {
                                return {
                                  ...item,
                                  chdChargeType: data,
                                };
                              }
                              return item;
                            }),
                          );
                        },
                        options: revCostOpt,
                        placeholder: "Select Charge Type",
                        value: params.data.chdChargeType,
                      }),
                    },
                    {
                      headerName: "Description",
                      field: "chdDescription",
                      cellEditor: "agTextCellEditor",
                      cellEditorParams: {
                        maxLength: 100,
                      },
                      tooltipValueGetter: (params) => {
                        return "press Enter to set the value";
                      },
                      editable: true,
                      cellRenderer: ResizableScrollingTextRenderer,
                    },
                    {
                      headerName: "Value",
                      field: "chdValue",
                      editable: true,
                      cellEditor: "agNumberCellEditor",
                      tooltipValueGetter: (params) => {
                        return "press Enter to set the value";
                      },
                    },
                    {
                      headerName: "Qty",
                      field: "chdQty",
                      cellEditor: "agNumberCellEditor",
                      editable: true,
                      cellEditorParams: {
                        step: 1,
                        showStepperButtons: true,
                      },
                      tooltipValueGetter: (params) => {
                        return "press Enter to set the value";
                      },
                    },
                    {
                      headerName: "Total",
                      field: "chdTotal",
                    },
                    {
                      headerName: "UOM",
                      field: "chdUom",
                      cellRenderer: SelectRenderer,
                      cellRendererParams: (params) => ({
                        onChangeHandler: (data) => {
                          setGridData((prev) =>
                            prev.map((item) => {
                              if (item.id === params.data.id) {
                                return {
                                  ...item,
                                  chdUom: data,
                                };
                              }
                              return item;
                            }),
                          );
                        },
                        options: uomOpt,
                        placeholder: "Select UOM",
                        value: params.data.chdUom,
                      }),
                    },
                    {
                      headerName: "Status",
                      field: "chdStatus",
                      cellRenderer: SelectRenderer,
                      cellRendererParams: (params) => ({
                        onChangeHandler: (data) => {
                          setGridData((prev) =>
                            prev.map((item) => {
                              if (item.id === params.data.id) {
                                return {
                                  ...item,
                                  chdStatus: data,
                                };
                              }
                              return item;
                            }),
                          );
                        },
                        options: statusOpt,
                        placeholder: "Select Status",
                        value: params.data.chdStatus,
                      }),
                    },
                    {
                      headerName: "Active",
                      field: "chdActive",
                      cellRenderer: SelectRenderer,
                      cellRendererParams: (params) => ({
                        onChangeHandler: (data) => {
                          setGridData((prev) =>
                            prev.map((item) => {
                              if (item.id === params.data.id) {
                                return {
                                  ...item,
                                  chdActive: data,
                                };
                              }
                              return item;
                            }),
                          );
                        },
                        options: activeOpt,
                        placeholder: "Select Active",
                        value: params.data.chdActive,
                      }),
                    },
                    {
                      field: "delete",
                      cellRenderer: ButtonRenderer,
                      cellRendererParams: (params) => ({
                        clickHandler: () => {
                          setGridData((prev) =>
                            prev.filter((item) => item.id !== params.data.id),
                          );
                          setRowCount((prev) => prev - 1);
                        },
                        label: "Delete",
                        className: "ui red button",
                      }),
                    },
                  ]}
                />
                <div className="ui divider"></div>

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    type="submit"
                    template="create"
                    isLoading={isSubmitLoading}
                    onClick={(e) => {
                      addCharge(e);
                    }}
                    disabled={!(gridData.length > 0 && selectedRows.length > 0)}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <Modal ref={modalRef} minHeight="50vh" minWidth="50vw">
        <form className="ui form segment">
          <div className="two fields">
            <Input
              type="text"
              label="Template Name"
              placeholder="Template Name"
              required={true}
              value={templateName}
              onChange={(e) => {
                setTemplateName(e.target.value);
              }}
              error={currentErrors.intTemplateName}
              resetError={() =>
                setCurrentErrors((prevState) => {
                  const { intTemplateName: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
            <Dropdown
              label="Category"
              required={true}
              clearable
              placeholder="Select Category"
              options={customerSupplierOpt}
              value={category}
              onChange={(e, data) => setCategory(data.value)}
              error={currentErrors.intCategory}
              resetError={() =>
                setCurrentErrors((prevState) => {
                  const { intCategory: _, ...rest } = prevState;
                  return rest;
                })
              }
            />
          </div>

          <div className="field">
            <Input
              type="text"
              label="Description"
              placeholder="Description"
              value={templateDescription}
              onChange={(e) => {
                setTemplateDescription(e.target.value);
              }}
            />
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div className="field" style={{ width: "100%" }}>
              <Button
                type="submit"
                template="create"
                isLoading={savingTemplate}
                onClick={(e) => {
                  saveAsTemplate(e);
                }}
              />
            </div>
          </div>
        </form>
      </Modal>
    </>
  );
};

export default AddMultipleCharges;
